import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCourseTrackingPin = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 28 39",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M.94 15.8805.94 15.8803C.9442 11.8885 2.3699 8.0792 4.8778 5.2842 7.3825 2.4929 10.755.945 14.2484.94 17.7417.945 21.1144 2.4929 23.619 5.2842 26.1269 8.0792 27.5526 11.8885 27.5569 15.8803V15.8805C27.561 19.1376 26.6058 22.2968 24.8508 24.8733L24.7688 24.9938 24.7681 24.9964 24.6504 25.1674C24.5984 25.2429 24.5452 25.3198 24.5017 25.3823 24.4799 25.4137 24.4612 25.4403 24.4467 25.461 24.4392 25.4717 24.4339 25.4791 24.4305 25.4838 24.4286 25.4865 24.4273 25.4884 24.4265 25.4895 24.4255 25.4908 24.4253 25.4911 24.4257 25.4905L14.2484 38.8676 4.0706 25.4902 4.0706 25.4902 4.0668 25.4852C4.067 25.4855 4.0664 25.4846 4.0649 25.4826 4.0585 25.4737 4.0367 25.4432 3.9961 25.3849 3.9525 25.3225 3.8993 25.2455 3.8472 25.1697 3.7953 25.0941 3.7453 25.0211 3.7081 24.9668L3.6637 24.9016 3.6514 24.8837 3.6482 24.879 3.6474 24.8779 3.6473 24.8777C1.8914 22.2999.9357 19.1392.94 15.8805Z",
		fill: "currentColor",
		stroke: "#fff",
		strokeWidth: 1.4,
		strokeLinejoin: "round"
	})]
});
const ForwardRef = forwardRef(SvgCourseTrackingPin);
export { ForwardRef as ReactComponent };
